import React, { type ReactNode } from 'react';

import { Link } from 'react-router-dom';

import { AttachedIcon, Interior, Label } from './components';
import { ChipColor, type ChipColorValue, ChipSize, type ChipSizeValue } from './types';

import { ChipWrapper } from './styles';

// TODO: Consider passing a `disabled` prop for <button />.
export interface ChipProps {
    children: ReactNode;
    ariaLabel?: string;
    color?: ChipColorValue;
    size?: ChipSizeValue;
    to?: string;
    onClick?(): void;
    // TODO: Remove this prop once we can decouple it
    // from <FilterLink />.
    active?: boolean;
    // TODO: We should not allow this `clickable` prop.
    clickable?: boolean;
}

export function Chip({
    children,
    ariaLabel,
    color = ChipColor.Default,
    size = ChipSize.Medium,
    to,
    onClick,
    active = false,
    clickable = false,
}: ChipProps) {
    const interactive = Boolean(onClick || to?.length);
    const isClickable = interactive || clickable;

    const Element = interactive ? (to ? Link : 'button') : 'div';

    return (
        <ChipWrapper
            as={Element}
            aria-label={ariaLabel}
            to={to}
            $color={active ? ChipColor.Active : color}
            $size={size}
            $clickable={isClickable}
            onClick={onClick}
        >
            {children}
        </ChipWrapper>
    );
}

Chip.AttachedIcon = AttachedIcon;
Chip.Interior = Interior;
Chip.Label = Label;
